import { useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { toLower } from 'ramda';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMessage } from '@gef-ui/localization/messages';

import { gtmDashboardSectionNames } from 'features/views/dashboard/constants';
import { useButtonClickDataLayer } from 'features/views/dashboard/hooks';
import { getTasksAndInformation } from 'features/views/dashboard/tasksAndInformation/selectors';

export const TableOverview = () => {
	const navigate = useNavigate();

	const pushToClickButtonDataLayer = useButtonClickDataLayer();

	const { newTasks = 0, newInformation = 0, informationTotal = 0 } = useSelector(getTasksAndInformation);

	const handleRedirect = useCallback(
		(type, typeName) => () => {
			pushToClickButtonDataLayer({
				value: gtmDashboardSectionNames.TASKS,
				button_text: toLower(typeName),
			})();

			navigate({
				pathname: '/tasks',
				search: `?quickFilter=${type}`,
			});
		},
		[navigate, pushToClickButtonDataLayer],
	);

	return (
		<Table
			size="small"
			sx={{
				border: 'none !important',
				'& .MuiTableCell-root': {
					px: 0,
					py: 0.5,
					borderBottom: 'unset',
				},
				'& .MuiTableRow-root': {
					cursor: 'pointer',
				},
			}}
		>
			<TableBody>
				<TableRow
					onClick={handleRedirect('tasks', getMessage('dashboard:tasksAndInformation.newTasksToSolve'))}
				>
					<TableCell>
						<Typography
							variant="body1"
							sx={{
								fontWeight: 400,
							}}
						>
							{getMessage('dashboard:tasksAndInformation.newTasksToSolve')}
						</Typography>
					</TableCell>
					<TableCell align="right">
						<Typography
							variant="body1"
							color="text.secondary"
							sx={{
								fontWeight: 700,
							}}
						>
							{newTasks}
						</Typography>
					</TableCell>
				</TableRow>
				<TableRow
					onClick={handleRedirect('info', getMessage('dashboard:tasksAndInformation.allInformationToSolve'))}
				>
					<TableCell>
						<Typography
							variant="body1"
							sx={{
								fontWeight: 400,
							}}
						>
							{getMessage('dashboard:tasksAndInformation.allInformationToSolve')}
						</Typography>
					</TableCell>
					<TableCell align="right">
						<Typography
							variant="body1"
							color="text.secondary"
							sx={{
								fontWeight: 700,
							}}
						>
							{informationTotal}
						</Typography>
					</TableCell>
				</TableRow>
				<TableRow
					onClick={handleRedirect('info', getMessage('dashboard:tasksAndInformation.newInformationToSolve'))}
				>
					<TableCell>
						<Typography
							variant="body1"
							sx={{
								fontWeight: 400,
							}}
						>
							{getMessage('dashboard:tasksAndInformation.newInformationToSolve')}
						</Typography>
					</TableCell>
					<TableCell align="right">
						<Typography
							variant="body1"
							color="text.secondary"
							sx={{
								fontWeight: 700,
							}}
						>
							{newInformation}
						</Typography>
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
};

export default TableOverview;
